import styled from 'styled-components';

import { breakpoints } from '../../../lib/constants';
import { FlexContainerRow, FlexContainerRowInner, FlexContainerRowLRPadding, PageWrapper } from '../skylab/page';

export const TierIntroContainer = styled.div``;

export const TierSelectionPageWrapper = styled(FlexContainerRowLRPadding)`
  @media (max-width:869px) {
    flex-direction: column;
    margin-top: 50px;
    > * {
      width: 100%;
    }

    > *:last-child {
      width: 100%;
    }
  }

  @media (max-width:${breakpoints.phone}px) {
    padding:0 5px;
    margin-top: 0px;
  }
`;

export const PickerContainer = styled(FlexContainerRowInner)`
  position: relative;
  max-width: 980px;
  margin: 35px auto 10px;
  > div {
    margin-right: 10px;
  }
`;

export const PickerInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  flex-grow: 1;
  align-items: flex-end;

  @media (max-width:${breakpoints.phone}px) {
    width: 100%;
    margin-top: 15px;
  }

  && {
    * {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
      font-weight: 300;
    }

    strong {
      font-weight: 600;
    }
  }
`;

export const ExtractorPickerInfo = styled.div<{ selected: boolean }>`
  border-color: ${(props) => (props.selected ? 'var(--color-interaction-surface-selected)' : 'var(--color-surface-muted)')};
  background-color: ${(props) => (props.selected ? 'var(--color-interaction-surface-selected)' : 'var(--color-surface-muted)')};
  padding: 10px 5px 0 5px;
  width: 90%;
  * {
    font-size: 1.05em;
  }

  p {
    margin-bottom: 0px;
  }
`;

const PickerQuantity = styled.div`
  border-bottom: 1px solid var(--color-border-muted);
  padding: 15px 5px;

  && {
    > * {
      margin-bottom: 0;
      line-height: 1em;
    }

    p > span {
      font-weight: 400;
    }

    p {
      line-height: 20px;
    }
  }
`;

export const ExtractorPickerQuantity = styled(PickerQuantity)`
  background-color: inherit;
  border-color: inherit;
`;

const PickerPrice = styled.div<{ peryear?: string }>`
  align-items: center;
  display: block;
  justify-content: center;
  max-width: 100%;
  min-height: 90px;
  padding: 0px 5px;
  position: relative;
  width: 100%;
  max-width: 100%;

  > p {
    font-size: 2.75em;
    line-height: .7em;
    margin-bottom: 0;
    ${(props) =>
      props.peryear
        ? `&::after{ content: "${props.peryear}"; clear: left; display: block; font-size:.4em; margin:0 0 0 3px; padding-top: 10px; }`
        : ''}
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    max-width: 100%;
  }
`;

export const ExtractorPickerPrice = styled(PickerPrice)<{ isSupportTile?: boolean }>`
  background-color: inherit;
  border-color: inherit;

  ${(props) => (props.isSupportTile ? '> p { font-size: 1.3em; line-height: inherit }' : '')}
`;

const PickerButtonContainer = styled.div<{ contact?: boolean }>`
  background-color: var(--color-surface-muted);
  border: 1px solid var(--color-border-default);
  border-top: 2px solid var(--color-border-default);
  ${(props) => (props.contact ? 'font-size: .90em;' : '')}
  padding: 20px;
  min-height: 85px;

  p {
    width: 100%;
    max-width: 100%;
  }

  button {
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 1em;
  }

  && {
    button {
      font-weight: 400;
      display: block;

      &:before,
      &:after {
        content: '';
        display: table;
        visibility: hidden;
        width: 100%;
      }
    }
  }
`;

export const ExtractorPickerButtonContainer = styled(PickerButtonContainer)<{ isSupportTile?: boolean }>`
  background-color: inherit;
  border-color: inherit;

  ${(props) => (props.isSupportTile ? 'padding-right: 0px; padding-left: 0px;' : '')}
`;

export const TierPlanButton = styled.button`
  position: relative;
  &.active {
    color: var(--color-text-primary);
    margin: 0 auto;
  }
  &:focus {
    box-shadow: none;
  }
`;

const ActiveTierCheckMark = styled.div`
  position: relative;
  top: 0;
  left: 0;
  margin: 0;
  transform: translateY(-205%);
  s-icon {
    border: 1px solid var(--color-border-default);
    border-radius: 100px;
    background: var(--color-surface-canvas);
    color: var(--color-brand-orange);
    display: block;
    font-size: 2.142em;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    line-height: 1;
    margin: 0 0 -20px;
    padding: 5px;
    speak: none;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
  }
`;

export const ExtractorActiveTierCheckMark = styled(ActiveTierCheckMark)`
  transform: translateY(-25%);
  s-icon {
    border: 2px solid var(--color-brand-orange);
    padding: 0 5px 5px 5px;
  }
`;

export const HelpContainer = styled.div`
  margin-bottom: 30px;
  text-align: center;

  @media (max-width:${breakpoints.phone}px) {
    padding: 20px 10px;
    margin-bottom: 10px;
  }
`;

export const BaseLinkContainer = styled(FlexContainerRow)`
  margin-right: 30px;

  > *:last-child {
    text-align: right;
  }
`;

export const ThankyouPageWrapper = styled(PageWrapper)`
  max-width: 980px;
  padding-left: 30px;
  padding-right: 30px;
`;

export const ThankyouContentContainer = styled(FlexContainerRow)`
  > * {
    position: relative;
  }
`;

export const ThankyouContent = styled.div`
  font-size: 1.285em;
`;

export const ThankyouButton = styled.button`
  margin-top: 35px;
  padding: 10px 25px;
`;
